import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class WhatsappAdminService extends BaseService<any> {
  constructor() {
    super("whatsapp");
  }
  // Подключаем Whatsapp
  async connect(channelConnectionID: number) {
    return appAxios.get(`/admin/orgs/${localStorage.getItem("orgID")}/whatsapp/connect/${channelConnectionID}`);
  };
  // Получаем статус подключения Whatsapp
  async getStatus(channelConnectionID: number) {
    return appAxios.get(`/admin/orgs/${localStorage.getItem("orgID")}/whatsapp/status/${channelConnectionID}`);
  };

  async singin(phone: string) {
    return appAxios.post(`/auth/whatsapp/sign`, { phone });
  }
  async verify(phone: string, password: string) {
    return appAxios.post(`/auth/whatsapp/verify`, { phone, password });
  }
  async sendMessage(channelConnectionID: number, to: string, text: string) {
    return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/whatsapp/send-message/${channelConnectionID}`, {
      to,
      text,
    });
  }
}

export default new WhatsappAdminService();
